module.exports = __webpack_public_path__ + "static/img/no_profile.f41d91c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no_profile.png
// module id = kPi+
// module chunks = 1